import * as RecommendationActions from 'src/app/_store/_recommendation/actions/recommendation.actions';

export { RecommendationActions };
